import { agentApiHeaders, apiBase, chatApiRequest } from '../agentApi'
import axios from '../axiosInstance'
import { ByoAgent, ChatApp } from './types'

/** BYO agent CRUD. Rejects on failure; the sagas branch on `catch`. */

const agentsBase = (app: ChatApp): string => `${apiBase(app)}/ai-agents/agents`

/** The endpoint ignores `page` and `search` and returns every agent. */
export async function listAgents(app: ChatApp): Promise<ByoAgent[]> {
  return chatApiRequest<ByoAgent[]>(() =>
    axios.get(agentsBase(app), { headers: agentApiHeaders(app) }),
  )
}

export async function updateAgent(
  app: ChatApp,
  uid: string,
  agentData: { isActive: boolean },
): Promise<unknown> {
  return chatApiRequest<unknown>(() =>
    axios.patch(`${agentsBase(app)}/${encodeURIComponent(uid)}`, agentData, { headers: agentApiHeaders(app) }),
  )
}

export async function deleteAgent(app: ChatApp, uid: string): Promise<unknown> {
  return chatApiRequest<unknown>(() =>
    axios.delete(`${agentsBase(app)}/${encodeURIComponent(uid)}`, { headers: agentApiHeaders(app) }),
  )
}
